import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React, { useState } from 'react';
import { UploadFile } from '../../../../pages/docs/componenets/upload-file/upload-file';
import { FileUploadFile } from 'primereact/fileupload';
import { uploadContractFileOperation } from './operations/upload-contract-file-operation';
import { toast } from 'react-toastify';
import { uploadSignContractFileOperation } from './operations/upload-sing-contract-file-operation';

export interface ContractFilesDatamodel {
  text: string;
  color: string;
  branchId: number;
  userId: number;
  rateId: number;
  isSignContract: boolean;
  contractUrl?: string;
  onRefresh: () => Promise<void>;
}

export const ContractFiles: React.FC<ContractFilesDatamodel> = ({
  text,
  color,
  branchId,
  userId,
  rateId,
  isSignContract,
  contractUrl,
  onRefresh,
}) => {
  const [uploadedFile, setUploadedFile] = useState<FileUploadFile>();
  const [showUploadDialog, setShowUploadDialog] = useState(false);

  const handleUploadFile = async () => {
    setShowUploadDialog(true);
  };

  const handleDialogHide = () => {
    setShowUploadDialog(false);
  };

  const handleFileUploaded = async (file: FileUploadFile) => {
    setUploadedFile(file);
    setShowUploadDialog(false);

    try {
      isSignContract
        ? await uploadSignContractFileOperation(
            branchId,
            userId,
            rateId,
            isSignContract,
            file,
          )
        : await uploadContractFileOperation(
            branchId,
            userId,
            rateId,
            isSignContract,
            file,
          );

      await onRefresh();
    } catch (error) {
      console.error('Failed to upload contract:', error);
    }
  };

  const hasContract = !!contractUrl;

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.5rem',
    border: hasContract ? '2px solid #10B981' : '1px solid #E5E7EB',
    borderRadius: '0.5rem',
    backgroundColor: hasContract ? '#ECFDF5' : color,
    transition: 'all 0.2s ease',
  };

  const textStyle = {
    fontSize: '0.75rem',
    fontWeight: 500,
    color: hasContract ? '#065F46' : '#6B7280',
    marginRight: '0.5rem',
    whiteSpace: 'pre-line' as const,
  };

  const downloadContract = () => {
    if (contractUrl) {
      window.open(contractUrl, '_blank');
    }
  };

  return (
    <>
      <div style={containerStyle}>
        <span style={textStyle}>{hasContract ? `${text} ✓` : text}</span>

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          {hasContract ? (
            <>
              <Button
                style={{ width: '35px' }}
                icon="pi pi-download"
                text
                tooltip={'הורדת הקובץ'}
                onClick={downloadContract}
              />

              {/*<Button
                style={{ width: '35px' }}
                icon="pi pi-trash"
                text
                severity="danger"
                tooltip={'מחיקת הקובץ'}
              />*/}

              <Button
                style={{ width: '35px' }}
                icon="pi pi-cloud-upload"
                text
                severity="success"
                tooltip={'דריסת הקובץ'}
                onClick={handleUploadFile}
              />
            </>
          ) : (
            <Button
              style={{ width: '35px' }}
              icon="pi pi-cloud-upload"
              text
              severity="secondary"
              tooltip={'העלאת קובץ'}
              onClick={handleUploadFile}
            />
          )}
        </div>
      </div>

      <Dialog
        header={hasContract ? 'דריסת קובץ חוזה' : 'העלאת קובץ חוזה'}
        visible={showUploadDialog}
        style={{ width: '450px' }}
        onHide={handleDialogHide}
        modal
      >
        <div style={{ padding: '1rem' }}>
          <UploadFile onFileUploaded={handleFileUploaded} />
        </div>
      </Dialog>
    </>
  );
};
